import { Model as o } from "../../../../model.js";
class i extends o {
  constructor(e) {
    super(), this.locationId = e.locationId, this.devices = e.devices;
  }
}
export {
  i as StripeReaderConfigurationModel
};
//# sourceMappingURL=stripeReaderConfiguration.model.js.map
